import { ChartBreakdownOption } from './chart-breakdown-option.model';

export const ChartBreakdownStaticOptions = {
  none: { label: 'None', value: 'none' } as ChartBreakdownOption,
  createdBy: { label: 'Created By', value: 'createdBy' } as ChartBreakdownOption,
  project: { label: 'Project', value: 'project' } as ChartBreakdownOption,
  team: { label: 'Team', value: 'team' } as ChartBreakdownOption,
  workflowColumns: { label: 'Workflow Columns', value: 'columns' } as ChartBreakdownOption,
  categories: { label: 'Categories', value: 'categories' } as ChartBreakdownOption,
};
